import { formatPricing, formatSimpleDate, getMOAName } from "@dune/utils";
import { ReceiptExtendedInfo } from "@dune/types";
import { ColumnDef } from "@tanstack/react-table";
import { ReceiptStatusBadge } from "../../../component/receipt/ReceiptStatusBadge";
import { ReceiptTypeBadge } from "../../../component/receipt/ReceiptTypeBadge";

const receiptColumns: ColumnDef<ReceiptExtendedInfo>[] = [
	{
		accessorKey: "reference",
		header: "Ref",
		cell: ({ row }) => (
			<div className="font-medium">{row.getValue("reference")}</div>
		),
	},
	{
		accessorKey: "clientDetails",
		header: "Maître d'ouvrage",
		cell: ({ row }) => {
			const clientDetails = row.original.clientDetails;
			return <div>{clientDetails ? getMOAName(clientDetails) : "-"}</div>;
		},
	},
	{
		accessorKey: "type",
		header: "Type",
		cell: ({ row }) => <ReceiptTypeBadge type={row.original.type} />,
	},
	{
		accessorKey: "issueDate",
		header: "Date d'émission",
		cell: ({ row }) => (
			<div className="text-sm">
				{formatSimpleDate(row.getValue("issueDate"))}
			</div>
		),
	},
	{
		accessorKey: "totalClientPrimeTTC",
		header: "Prime TTC",
		cell: ({ row }) => {
			const value = row.original.totalClientPrimeTTC;

			if (!value) {
				return <div className="text-sm">-</div>;
			}

			return <div className="text-sm">{formatPricing(value)}</div>;
		},
	},
	{
		accessorKey: "totalClientPrimeWithoutBrokerRemuneration",
		header: "Prime rémunération déduite",
		cell: ({ row }) => {
			const value = row.original.totalClientPrimeWithoutBrokerRemuneration;

			if (!value) {
				return <div className="text-sm">-</div>;
			}

			return <div className="text-sm">{formatPricing(value)}</div>;
		},
	},
	{
		accessorKey: "amountPaid",
		header: "Montant réglé",
		cell: ({ row }) => (
			<div className="text-sm">{formatPricing(row.getValue("amountPaid"))}</div>
		),
	},
	{
		accessorKey: "lastPaymentDate",
		header: "Date de règlement",
		cell: ({ row }) => {
			const value = row.getValue<Date | null>("lastPaymentDate");

			if (!value) {
				return <div className="text-sm">-</div>;
			}

			return <div className="text-sm">{formatSimpleDate(value)}</div>;
		},
	},
	{
		accessorKey: "outstandingAmount",
		header: "Restant à régler",
		cell: ({ row }) => {
			const value = row.getValue<number | null>("outstandingAmount");

			if (!value) {
				return <div className="text-sm">-</div>;
			}

			return <div className="text-sm">{formatPricing(value)}</div>;
		},
	},
	{
		accessorKey: "status",
		header: "Statut",
		cell: ({ row }) => {
			const status = row.original.status;
			return <ReceiptStatusBadge status={status} />;
		},
	},
];

export { receiptColumns };
